import { render, staticRenderFns } from "./ChannelCredentialsSimpleCmp.vue?vue&type=template&id=6b7ca978&scoped=true&"
import script from "./ChannelCredentialsSimpleCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelCredentialsSimpleCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCredentialsSimpleCmp.vue?vue&type=style&index=0&id=6b7ca978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ca978",
  null
  
)

export default component.exports